<template>
  <v-app>
    <template v-if="onlyRouterView">
      <div v-if="appLoading" class="col-sm-12 p-0 dash-loader">
        <img src="/images/loader.gif" class="loader-img" alt="loader" />
      </div>
      <router-view v-else></router-view>
    </template>
    <template v-else>
      <h5 v-if="isOffline" class="information">
        'You are offline! Please connect with internet for better result.'
      </h5>
      <pwa-modal></pwa-modal>
      <force-update></force-update>
      <div v-if="appLoading" class="col-sm-12 p-0 dash-loader">
        <img src="/images/loader.gif" class="loader-img" alt="loader" />
      </div>
      <router-view v-else></router-view>

      <!-- for tab view -->
      <restrict-portrait-mode v-if="restrictPortrait" />
      <force-download-mobile-version
        v-if="activeMobileView"
      ></force-download-mobile-version>

      <vc-snackbar></vc-snackbar>
      <v-dialog
        :persistent="orderSummary.persistent"
        :value="orderSummary.visible"
        content-class="v-dialog-lg dialog-lg"
      >
        <OrderSummary />
      </v-dialog>
      <login-as ref="login" />
    </template>
  </v-app>
</template>

<script>
import disableAutoComplete from "@/methods/vueDisableAutocomplete";
import General from "@/methods/utilities";
import OrderSummary from "@/components/general/modal/OrderSummary";
const TopNavigation = () => import("@/components/general/master/TopNavigation");
const SubHeader = () => import("@/components/general/master/SubHeaderNew");
import BottomNavigation from "@/components/general/master/BottomNavigation";
import reviewRating from "@/components/general/reviewRating";
import HomePage from "@/components/authorization/HomePage";
import { mapState } from "vuex";
import SnackBar from "@/components/general/SnackBar";
import pwaModal from "@/components/pwaModal.vue";
import restrictPortraitMode from "@/components/elements/restrictPortraitMode";
import Swal from "sweetalert2";
window.Swal = Swal;
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import { bus } from "@/main.js";
import config from "@/config.js";
const forceDownloadMobileVersion = () =>
  import("@/components/elements/forceDownloadMobileVersion.vue");
export default {
  mixins: [disableAutoComplete, General],
  name: "App",
  metaInfo: {
    title: "A Secure and Confidential health care portal on your fingertips",
    titleTemplate: "DocSmart - %s",
    meta: [
      {
        name: "description",
        content:
          "A Secure and Confidential health care portal on your fingertips. DocSmart helps in linking all health care services under a Common cloud based Health care Ecosystem (HES)."
      },
      {
        property: "og:title",
        content:
          "A Secure and Confidential health care portal on your fingertips"
      },
      { property: "og:site_name", content: "DocSmart" },
      {
        property: "og:description",
        content:
          "A Secure and Confidential health care portal on your fingertips. DocSmart helps in linking all health care services under a Common cloud based Health care Ecosystem (HES)."
      },
      {
        property: "og:image",
        content: "https://docsmart.in/img/icons/favicon-32x32.png"
      }
    ]
  },
  meta: [
    {
      name: "description",
      content:
        "A Secure and Confidential health care portal on your fingertips. DocSmart helps in linking all health care services under a Common cloud based Health care Ecosystem (HES)."
    }
  ],
  components: {
    "top-navigation": TopNavigation,
    "sub-header": SubHeader,
    "bottom-navigation": BottomNavigation,
    "pwa-modal": pwaModal,
    homepage: () =>
      import(
        /* webpackChunkName: "HomePage" */ "@/components/authorization/HomePage"
      ),
    OrderSummary,
    // Loading,
    "vc-snackbar": SnackBar,
    "review-ratings": reviewRating,
    "force-update": () => import("@/components/forceUpdate"),
     "login-as": () => import("@/components/general/modal/loginAsN"),
    "restrict-portrait-mode": restrictPortraitMode,
    "force-download-mobile-version": forceDownloadMobileVersion
  },
  computed: {
    ...mapState({
      isLoggedin: state => {
        return state.user.loggedIn;
      }
    }),
    commonRoutes() {
      let generalRoutes = [
        "/privacy-policy",
        "/medical-certificate",
        "/terms-conditions",
        "/services",
        "/about-us",
        "/contact-us",
        "/UploadView",
        "/FAQ"
      ];
      let path = this.$route.path;
      if (generalRoutes.includes(path)) {
        return true;
      } else {
        return false;
      }
    },
    orderSummary() {
      return this.$store.getters["general/orderSummaryModal"];
    },
    onlyRouterView() {
      return this.$route.meta.onlyRouterView || false;
    },
    screenWidth() {
      return this.$screen.width;
    },
    screenHeight() {
      return this.$screen.height;
    }
  },
  data() {
    return {
      SnackBar: this.$store.getters["general/getSnackbar"],
      isOffline: false,
      restrictPortrait: false,
      activeMobileView: false
    };
  },
  created() {
    const mapScript = document.createElement("script");
    mapScript.setAttribute(
      "src",
      `https://maps.googleapis.com/maps/api/js?key=${config.G_MAP_API_KEY}&libraries=geometry,places`
    );
    document.head.appendChild(mapScript);
  },
  async mounted() {
    this.checkOrientation();
    await this.getRemoteData();
    this.redirectToProject(this.$route.path);
  },

  watch: {
    screenWidth: {
      handler(newValue) {
        if (newValue) this.checkOrientation();
      },
      deep: true
    },
    screenHeight: {
      handler(newValue) {
        if (newValue) this.checkOrientation();
      },
      deep: true
    }
  },
  methods: {
    checkOrientation() {
      // for tab screen
      if (this.$screen.md) {
        if (this.$screen.portrait) {
          this.restrictPortrait = true;
          this.activeMobileView = false;
          this.$forceUpdate();
        } else {
          // for mobile screen rotate
          if (this.screenWidth <= 915 && this.screenHeight <= 412) {
            this.restrictPortrait = false;
            this.activeMobileView = true;
            this.$forceUpdate();
          }
          // for tab screen rotate
          else {
            this.activeMobileView = false;
            this.restrictPortrait = false;
            this.$forceUpdate();
          }
        }
      }
      // for mobile screen
      else if (this.$screen.xs || this.$screen.sm) {
        this.restrictPortrait = false;
        this.activeMobileView = true;
        this.$forceUpdate();
      } else {
        this.activeMobileView = false;
        this.restrictPortrait = false;
        this.$forceUpdate();
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.mt-172 {
  margin-top: 172px;
}
.information {
  text-align: center;
  color: white;
  background: black;
  margin-top: 0px;
  z-index: 9999;
}

@media screen and (max-width: 600px) {
  .mt-172 {
    margin-top: 44px;
  }
}
</style>
